import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { Api } from '../api/api';
import { Storage } from '../utils/Storage';
import i18n from '../lang/config';

const STATUS_IDLE = 'idle';
const STATUS_LOADING = 'loading';
const STATUS_SUCCEEDED = 'succeeded';
const STATUS_FAILED = 'failed';

const initialState = {
    availableLanguages: {},
    status: STATUS_IDLE,
};

export const fetchAvailableLanguages = createAsyncThunk(
    'language/fetchAvailableLanguages',
    async () => {
        const response = await Api.getAvailableLanguages();
        return response.languages;
    }
);

export const saveLanguage = createAsyncThunk(
    'language/saveLanguage',
    async (lang) => {
        await Api.setLanguage(lang);
        i18n.changeLanguage(lang);
        Storage.setLanguage(lang);
        window.location.reload();
        return lang;
    }
);

// Applies a language locally (i18n + Storage) without calling the API
export const applyLanguage = (lang) => () => {
    i18n.changeLanguage(lang);
    Storage.setLanguage(lang);
    window.location.reload();
};

export const slice = createSlice({
    name: 'language',
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchAvailableLanguages.pending, (state) => {
                state.status = STATUS_LOADING;
            })
            .addCase(fetchAvailableLanguages.fulfilled, (state, action) => {
                state.status = STATUS_SUCCEEDED;
                state.availableLanguages = action.payload || {};
            })
            .addCase(fetchAvailableLanguages.rejected, (state) => {
                state.status = STATUS_FAILED;
            });
    }
});

export const selectAvailableLanguages = state => state.language.availableLanguages;
export const selectAvailableLanguagesLoaded = state => state.language.status === STATUS_SUCCEEDED;

export default slice.reducer;
